// import React, { useState, useRef, useContext, useReducer, useMemo, useEffect, useCallback } from 'react';
// import { Route, useHistory } from 'react-router';
// import { IonIcon, IonRouterOutlet, IonTabs, IonTabBar, IonTabButton, IonLabel } from '@ionic/react';
// import '../../styles/appTabs/AppTabs.scss';
// import chatboxesIcon from '../../assets/icons/chatBoxIconGrey.svg';
// import homeIcon from '../../assets/icons/homeIcon.svg';
// import mapPinIcon from '../../assets/icons/mapPinIcon.svg';
// import profIcon from '../../assets/icons/profileIcon.svg';
// import smallGloveIcon from '../../assets/icons/smallGloveIcon.svg';
// import { PageContext, PageDispatchContext, TakerNotificationContext } from '../../contexts/AppContexts';
// import { AppContext } from '../../global/AppContext';
// import MatchmakingContext from '../../global/MatchmakingContext';
// import { ProductTourContext } from '../../global/ProductTourContext';
// import { getLiveBets } from '../../global/request/bet';
// import useProfile from '../../global/useProfile';
// import { AuthContext } from '../authentication/AuthContext';
// import { StartFightContextProvider } from '../fight/StartFightContext';
// import StartFightModal from '../fight/StartFightModal';
// import TakerFightProcess from '../fight/takerFightProcess/TakerFightProcess';
// import TakerNotification from '../fight/takerFightProcess/TakerNotification';
// import FriendProfile from '../friendProfile/FriendProfile';
// import FriendsListPage from '../friendProfile/FriendsListPage';
// import Home from '../home/Home';
// import HomepageNotification from '../home/homepageNotifications/HomepageNotification';
// import EditProfile from '../profile/EditProfile';
// import Profile from '../profile/Profile';
// import Restaurant from '../restaurant/Restaurant';
// import SettingsModal from '../settingsModal/SettingsModal';
// import Sports from '../sports/Sports';
// import DefaultLanding from './DefaultLanding';

// group: react and core libs
import React, { useState, useRef, useContext, useReducer, useMemo, useEffect, useCallback } from 'react';
import { Route } from 'react-router';
// group: ionic + icons
import { IonIcon, IonRouterOutlet, IonTabs, IonTabBar, IonTabButton, IonLabel } from '@ionic/react';
// group: styles
import '../../styles/appTabs/AppTabs.scss';
// group: assets
import venueIconFilled from '../../assets/icons/beerFilled.svg';
import venueIconUnfilled from '../../assets/icons/beerUnfilled.svg';
import homeIconFilled from '../../assets/icons/homeFilled.svg';
import homeIconUnfilled from '../../assets/icons/homeUnfilled.svg';
import profIconFilled from '../../assets/icons/profileFilled.svg';
import profIconUnfilled from '../../assets/icons/profileUnfilled.svg';
import smallGloveIcon from '../../assets/icons/smallGloveIcon.svg';
// group: contexts
import { PageContext, PageDispatchContext, TakerNotificationContext } from '../../contexts/AppContexts';
import { AppContext } from '../../global/AppContext';
import MatchmakingContext from '../../global/MatchmakingContext';
import { ProductTourContext } from '../../global/ProductTourContext';
// group: hooks + utils
import { getLiveBets } from '../../global/request/bet';
import useProfile from '../../global/useProfile';
import { trackEvent } from '../../utils/customerio';
// group: components
import { AuthContext } from '../authentication/AuthContext';
import { StartFightContextProvider } from '../fight/StartFightContext';
import StartFightModal from '../fight/StartFightModal';
import TakerFightProcess from '../fight/takerFightProcess/TakerFightProcess';
import TakerNotification from '../fight/takerFightProcess/TakerNotification';
import FriendProfile from '../friendProfile/FriendProfile';
import FriendsListPage from '../friendProfile/FriendsListPage';
import Home from '../home/Home';
import HomepageNotification from '../home/homepageNotifications/HomepageNotification';
import EditProfile from '../profile/EditProfile';
import Profile from '../profile/Profile';
import Restaurant from '../restaurant/Restaurant';
import SettingsModal from '../settingsModal/SettingsModal';
import Sports from '../sports/Sports';
import DefaultLanding from './DefaultLanding';

const contextTemplate = {};
// DO WE NEED THAT FOR ANYTHING ?
// const ACTIONS = {
//   SET_MODAL_REF: 'setModalRef',
// };

function AppTabs() {
  const appCtx = useContext(AppContext);
  const authCtx = useContext(AuthContext);
  const bearerToken = authCtx.tokens.idToken;
  const [reloadProfile, profile] = useProfile();
  const { dispatch: matchmakingDispatch } = useContext(MatchmakingContext);
  const { restaurantButtonRef, fightButtonRef, profileButtonRef, visibility } = useContext(ProductTourContext);

  const settingsRef = useRef();
  const startFightRef = useRef();
  const takerProcessRef = useRef();
  const [takerProcessProps, setTakerProcessProps] = useState({});
  const [showTakerNotification, setShowTakerNotification] = useState(false);
  const [selectedFight, setSelectedFight] = useState(null);
  const [fights, setFights] = useState([]);

  useEffect(() => {
    reloadProfile();
  }, [authCtx.tokens, reloadProfile]);

  const [page, dispatch] = useReducer(
    (state, action) => {
      // eslint-disable-next-line no-unused-vars
      const updatedState = { ...state };

      switch (action.action) {
        default: {
          console.error('Invalid action', action.action);
          throw new Error('Invalid action');
        }
      }

      // return updatedState;
    },
    { ...contextTemplate },
  );

  // XXX: because headers are located on respective pages the image is loaded multiple times

  const pageContextValue = useMemo(
    () => ({
      ...page,
      modals: {
        settings: settingsRef,
        startFight: startFightRef,
        takerProcess: {
          setProps: setTakerProcessProps,
          ref: takerProcessRef,
        },
      },
    }),
    [page, settingsRef, startFightRef],
  );

  const dispatchContextValue = useMemo(() => ({ dispatch }), [dispatch]);

  const openTakerNotification = useCallback(
    fightData => {
      setShowTakerNotification(true);
      setSelectedFight(fightData);
    },
    [setShowTakerNotification, setSelectedFight],
  );

  const closeTakerNotification = useCallback(() => {
    setShowTakerNotification(false);
    setSelectedFight(null);
  }, [setShowTakerNotification, setSelectedFight]);

  const takerNotificationContextValue = useMemo(
    () => ({ openTakerNotification, closeTakerNotification }),
    [openTakerNotification, closeTakerNotification],
  );

  const [isStartFightOpen, setIsStartFightOpen] = useState(false);
  const lastFetchTimeRef = useRef(Math.floor(Date.now() / 1000));

  const fetchLiveFights = useCallback(async () => {
    if (isStartFightOpen) return;

    const updatedLiveFights = await getLiveBets(bearerToken);

    const now = Math.floor(Date.now() / 1000);
    const lastFetchTime = lastFetchTimeRef.current; // get newly created fights since last fetch
    const recentFights = updatedLiveFights.filter(fight => fight.timestamp >= lastFetchTime && fight.timestamp <= now);
    if (recentFights.length > 0) {
      setFights(prevFights => [...prevFights, ...recentFights]);
    }
    lastFetchTimeRef.current = now;
  }, [bearerToken, setFights, isStartFightOpen]);

  useEffect(() => {
    if (isStartFightOpen) return;
    fetchLiveFights();
    const interval = setInterval(fetchLiveFights, 1 * 60 * 1000);
    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [bearerToken, fetchLiveFights, isStartFightOpen]);

  useEffect(() => {
    if (!showTakerNotification && selectedFight === null && fights.length > 0) {
      const [nextFight, ...remainingFights] = fights;

      setFights(remainingFights);
      if (nextFight.takerName === profile?.name) {
        openTakerNotification(nextFight);
      }
    }
  }, [fights, showTakerNotification, selectedFight, openTakerNotification, profile?.name]);

  const handleProfileClick = useCallback(() => {
    const hasSeenProfileOnboarding = localStorage.getItem('profile_onboarding_seen');
    if (!hasSeenProfileOnboarding && window.cioanalytics && authCtx.accessData?.sub) {
      localStorage.setItem('profile_onboarding_seen', 'true');
      window.cioanalytics.identify(authCtx.accessData.sub, {
        email: profile?.username,
        name: profile?.username,
      });

      trackEvent('Profile_click', {
        user_id: authCtx.accessData?.sub,
        username: profile?.username,
        source: 'app_tabs',
      });
    }
  }, [authCtx.accessData?.sub, profile?.username]);

  return (
    <PageDispatchContext.Provider value={dispatchContextValue}>
      <PageContext.Provider value={pageContextValue}>
        <StartFightContextProvider>
          <TakerNotificationContext.Provider value={takerNotificationContextValue}>
            <IonTabs className='apptabs-navbar'>
              <IonRouterOutlet>
                <Route exact path='/app/home' component={Home} />
                <Route exact path='/app/sports' component={Sports} />
                <Route exact path='/app/restaurant' component={Restaurant} />
                <Route exact path='/app/profile' component={Profile} />
                <Route exact path='/app/profile/edit' component={EditProfile} />
                <Route exact path='/app/friendprofile/:userId' component={FriendProfile} />
                <Route exact path='/app/friendprofile/:userId/friendslist' component={FriendsListPage} />
                <Route exact path='/app/notificationCenter' component={HomepageNotification} />
                <Route component={DefaultLanding} />
              </IonRouterOutlet>
              <IonTabBar className='ion-tabbar' slot='bottom'>
                <IonTabButton className='ion-button' tab='home1' href='/app/home'>
                  <IonIcon icon={homeIconFilled} className='active-icon' />
                  <IonIcon icon={homeIconUnfilled} className='inactive-icon' />
                  <IonLabel>Home</IonLabel>
                </IonTabButton>
                <IonTabButton
                  id='restaurant-button'
                  ref={restaurantButtonRef}
                  className={`ion-button ${visibility.restaurantButtonRef ? '' : 'hidden'}`}
                  tab='restaurant'
                  href='/app/restaurant'>
                  <IonIcon icon={venueIconUnfilled} className='active-icon' />
                  <IonIcon icon={venueIconFilled} className='inactive-icon' />
                  <IonLabel>Venues</IonLabel>
                </IonTabButton>
                <IonTabButton
                  id='profile-button'
                  ref={profileButtonRef}
                  className={`ion-button ${visibility.profileButtonRef ? '' : 'hidden'}`}
                  tab='profile'
                  href='/app/profile'
                  onClick={handleProfileClick}>
                  <IonIcon icon={profIconFilled} className='active-icon' />
                  <IonIcon icon={profIconUnfilled} className='inactive-icon' />
                  <IonLabel>My Profile</IonLabel>
                </IonTabButton>
                <IonTabButton
                  id='fight-button'
                  ref={fightButtonRef}
                  className={`ion-button ${visibility.fightButtonRef ? '' : 'hidden'}`}
                  tab='fight'
                  onClick={() => {
                    if (appCtx.restaurant) {
                      matchmakingDispatch({ type: 'CLEAR_CHALLENGER' });
                      startFightRef.current.clearInitialState();
                      startFightRef.current.present();
                    } else {
                      alert('Please set a restaurant to fight!');
                    }
                  }}>
                  <div className='outer-circle'>
                    <div className='circle'>
                      <IonIcon icon={smallGloveIcon} className='glove' />
                    </div>
                  </div>
                  <IonLabel className='fight-label'> Start Fight </IonLabel>
                </IonTabButton>
              </IonTabBar>
            </IonTabs>
          </TakerNotificationContext.Provider>
        </StartFightContextProvider>
        <StartFightModal
          modalName='startFight'
          ref={startFightRef}
          onOpen={() => setIsStartFightOpen(true)}
          onClose={() => setIsStartFightOpen(false)}
        />
        {showTakerNotification && (
          <TakerNotification
            isOpen={showTakerNotification}
            onClose={closeTakerNotification}
            fightData={selectedFight}
          />
        )}
        <TakerFightProcess
          ref={takerProcessRef}
          fightData={takerProcessProps.fightData}
          optionalTakerVenue={takerProcessProps.optionalTakerVenue}
          onClose={takerProcessProps.onClose}
          notificationClose={takerProcessProps.notificationClose}
        />
        <SettingsModal modalName='settings' ref={settingsRef} />
      </PageContext.Provider>
    </PageDispatchContext.Provider>
  );
}

export default AppTabs;
